import React from 'react';

const Globalcontext = React.createContext();

export default Globalcontext;
